export const DELAY_TYPE = {
  DEBOUNCE: 'debounce',
  THROTTLE: 'throttle',
};
